import Vue from 'vue'
import VueRouter from 'vue-router'
import { LOGIN, LOGOUT } from '../store/mutation-types'
import paths from './paths'

Vue.use(VueRouter)

export function setupRouter (store) {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: paths.auth
  })

  if (store.getters.authorized) {
    router.addRoutes(paths.members)
  }

  // Navigation Guards
  router.beforeEach((to, from, next) => {
    // brfore login
    if (!store.getters.authorized) {
      // if login page then continue
      if (to.name === 'auth.login') {
        next()
        return
      }
      // else redirect to login page
      next({
        name: 'auth.login',
        query: {
          redirect: to.fullPath
        }
      })
      return
    }

    // after login
    if (to.matched.some(record => record.meta.auth)) {
      // if not authorized, redirect to login page
      if (!store.getters.authorized) {
        next({
          name: 'auth.login',
          query: {
            redirect: to.fullPath
          }
        })
        return
      }
    }
    next()
  })

  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case LOGIN: {
        // reference url: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
        const empty = new VueRouter({
          mode: 'history',
          base: process.env.BASE_URL,
          routes: paths.auth
        })
        // reset the previous routes
        router.matcher = empty.matcher
        const routes = state.auth.authorized ? paths.members : []
        if (routes.length !== 0) {
          router.addRoutes(routes)
        }
        break
      }
      case LOGOUT: {
        router.push({
          name: 'auth.login'
        })
        break
      }
    }
  })

  return router
}
